import { action, Config } from "utils";
import { Api } from "app";
import FilterStore from "./ActiveFilters";
import ResumeStore from "./Resumes";
import CreditStore from "./CreditStore";
import { Creators } from "./index";

var resumeTimer = null;

function doReloadResumes() {
  resumeTimer = null;
  action("RESUMES-LOADING");

  Api.post("resumes", FilterStore.getState(), function (data) {
    action("RESUMES-CHANGED", data);
  }).always(function () {
    action("RESUMES-READY");
  });
}

export function doReloadResumesAdmin() {
  resumeTimer = null;

  defaultFilters();
  reloadLanguages();
  reloadJobTypes();
  reloadAds();
}

export function doReloadResumesAdminAfter() {
  resumeTimer = null;
  reloadLanguages();
  reloadJobTypes();
  reloadAds();
  action("RESUMES-LOADING");
  Api.post("resumes-admin", FilterStore.getState(), function (data) {
    action("RESUMES-CHANGED", data);
  }).always(function () {
    action("RESUMES-READY");
  });
}

export function defaultFilters() {
  Api.post("default-filters/" + Config.adId, null, function (data) {
    if (Object.keys(Config.positionsFilters).length > 0) {
      let data = {
        store: "any",
        item: Config.positionsFilters,
      };
      action("SELECT-SUGGESTION", data);
    }
    action("APPLY-FILTERS", data);
    reloadQualifications();
    if (Object.keys(Config.areaFilters).length > 0) {
      addFilter(Config.areaFilters, "area");
    }
  }).then((data) => {
    action("RESUMES-LOADING");
    Api.post("resumes-admin", FilterStore.getState(), function (data) {
      action("RESUMES-CHANGED", data);
    }).always(function () {
      action("RESUMES-READY");
    });
  });
}

export function loading(page) {
  action("PAGE-LOADING", { page });
}

export function createCampaign() {
  showAddCampaign();
  action("CREATE-CAMPAIGN", {});
}

export function campaignNameChanged(name) {
  action("CAMPAIGN-NAME-CHANGED", { name });
}

var nextRequestId = 0;

export function addCampaign(name) {
  var requestId = nextRequestId++;
  var params = { name, requestId };
  action("ADD-CAMPAIGN", params);

  Api.post("publish", params, function (data) {
    action("CAMPAIGN-SAVED", data);
  }).then((data) => {
    hideAddCampaing();
  });
}

export function selectAll(status) {
  action("SELECT-ALL", { status });
}

export function sendInvitation(
  resumes,
  subject,
  message,
  textColor,
  color,
  logo
) {
  changeLoadingSendInvitation();
  const params = {
    resumes: resumes.map((item) => item.id),
    subject,
    message,
    textColor,
    color,
    logo,
  };

  Api.post(
    "send-admin-invitations/" + Config.adId,
    params,
    function (data) {}
  ).success(function (data) {
    action("SHOW-SUCCESS", data);
    setTimeout(function () {
      changeLoading();
    }, 2000);

    removeAllSelected();
  });
}

export function hideMessage() {
  action("HIDE-SUCCESS");
}

export function move(resumes, toFolder) {
  action("MOVE-IN-PROGRESS", { resumes, toFolder });

  showMessageContainer();

  const params = {
    resumes: resumes,
    folder: toFolder.id,
  };
  Api.post("move", params, function (data) {
    action("MOVE-FINISHED", data);
    reloadAds();
    reloadCredits();
  }).success(function () {
    setTimeout(function () {
      action("MOVE-CLOSED");
      hideMessageContainer();
    }, 3000);
  });
}

export function moveDone() {
  action("MOVE-DONE", {});
}

export function nextPage() {
  var { page } = FilterStore.getState();
  action("PAGE-CHANGED", { page: page + 1 });
  reloadResumes();
}

export function previousPage() {
  var { page } = FilterStore.getState();
  action("PAGE-CHANGED", { page: page - 1 });
  reloadResumes();
}

export function pageChanged(page) {
  action("PAGE-CHANGED", page);
  reloadResumes();
}

export function countChanged(page) {
  action("COUNT-CHANGED", page);
  reloadResumes();
}

export function reloadResumes() {
  if (resumeTimer !== null) {
    clearTimeout(resumeTimer);
  }

  resumeTimer = setTimeout(doReloadResumes, 250);
}

export function reloadResumesAdmin() {
  if (resumeTimer !== null) {
    clearTimeout(resumeTimer);
  }
  resumeTimer = setTimeout(doReloadResumesAdmin, 250);
  reloadLogIndex();
}

export function reloadAds() {
  Api.get("ads", null, function (data) {
    action("ADS-CHANGED", data);
  });
}

export function reloadCredits() {
  Api.post("credits", null, function (data) {
    action("CREDITS-CHANGED", data);
  });
}

export function reloadLatestResumes() {
  Api.post("latest-resumes", null, function (data) {
    action("LATEST-RESUMES-CHANGED", data);
  });
}

export function addFilter(filter, source = null) {
  action("ADD-FILTER", {
    filter: filter,
    source: source,
  });

  reloadResumes();
}

export function resumeSelected(resume, selected) {
  action("RESUME-SELECTED", {
    resume,
    selected,
  });
  hideMessageSendInvitation();
  closeUsersRemoveMsg();
}

export function blur(data) {
  action("BLUR", data);
}

export function hideRecommendations(data) {
  action("HIDE-RECOMMENDATIONS", data);
}

export function clearFilters() {
  action("CLEAR-FILTERS", {});
  reloadResumes();
}

export function removeFilter(filter) {
  console.log(filter);
  action("REMOVE-FILTER", { filter });
  reloadResumes();
}

export function queryChanged(query) {
  action("QUERY-CHANGED", query);

  findRecommendations(query);
}

export function nextSuggestion(data) {
  action("NEXT-SUGGESTION", data);
}

export function previousSuggestion(data) {
  action("PREVIOUS-SUGGESTION", data);
}

export function selectSuggestion(data) {
  action("SELECT-SUGGESTION", data);
  reloadResumes();
}

var recommendTimer = null;

function doFindRecommendations(query) {
  Api.post(
    "recommend",
    { find: query.query, filters: FilterStore.getState().filters },
    function (data) {
      console.log(data);

      action("RECOMMENDATIONS-CHANGED", {
        store: query.store,
        recommendations: data.recommendations,
      });

      action("LOADING-CHANGED", {
        loading: false,
      });
    }
  );
}

export function findRecommendations(query) {
  action("LOADING-CHANGED", {
    loading: true,
  });

  if (recommendTimer !== null) {
    clearTimeout(recommendTimer);
  }

  recommendTimer = setTimeout(function () {
    doFindRecommendations(query);
  }, 250);
}

export function loadResumeAdmin(id) {
  Api.post("resume/" + id, null, function (data) {
    action("USER-PROFILE", data);
  });
}

export function loadResume(id) {
  action("LOADING-RESUME", { id });

  Api.post("resume/" + id, null, function (data) {
    action("RESUME-CHANGED", data);
    reloadLatestResumes();
  });
}

export function reloadQualifications() {
  action("LOADING-QUALIFICATIONS");

  Api.post("qualifications", null, function (data) {
    action("QUALIFICATIONS-CHANGED", data);
  });
}
export function reloadLanguages() {
  Api.post("languages", null, function (data) {
    action("LANGUAGES-CHANGED", data);
  });
}

export function reloadTemplates() {
  action("LOADING-TEMPLATES");

  Api.post("templates", null, function (data) {
    action("TEMPLATES-CHANGED", data);
  });
  $(document).trigger("show-saved-templates");
}

export function reloadJobTypes() {
  action("LOADING-ADVANCED-FILTERS");

  Api.get("advanced-filters").then((response) => {
    action("ADVANCED-FILTERS-CHANGED", response);
  });
}

export function resetJobTypes() {
  action("RESET-JOBTYPES");
}

export function resetDriverLicenseTypes() {
  action("RESET-DRIVER-LICENSE-TYPES");
}

export function resetManagerExpirience() {
  action("RESET-MANAGERS-EXPIRIENCE");
}

export function showNoCredits() {
  $(document).trigger("show-no-credits");
}

export function hideNoCredits() {
  $(document).trigger("hide-no-credits");
}

export function showFilters() {
  $(document).trigger("show-filters");
}

export function showActiveUsers() {
  $(document).trigger("show-active-users");
}

export function showSavedTemplates() {
  $(document).trigger("show-saved-templates");
}

export function hideSavedTemplates() {
  $(document).trigger("hide-saved-templates");
}

export function hideFilters() {
  $(document).trigger("hide-filters");
}

export function showFolders() {
  const { total } = CreditStore.getState();
  const { resumes } = ResumeStore.getState();

  const checkedResumes = resumes.reduce(
    (acc, next) => acc + (next.checked ? 1 : 0),
    0
  );

  if (checkedResumes > total) {
    $(document).trigger("show-no-credits");
  } else {
    $(document).trigger("show-folders");
  }
}

export function hideFolders() {
  $(document).trigger("hide-folders");
}

export function showAddCampaign() {
  $(document).trigger("show-add-campaign");
}

export function hideAddCampaing() {
  $(document).trigger("hide-add-campaign");
}

export function toggleFilter(filter) {
  action("TOGGLE-FILTER", filter);
}

export function resetQualifications() {
  action("RESET-QUALIFICATIONS");
}

export function resetLanguages() {
  action("RESET-LANGUAGES");
}

export function resetLanguageLevel() {
  action("RESET-LANGUAGE-LEVEL");
}

export function resetExperience() {
  action("RESET-EXPERIENCE-RANGE");
}

export function experienceRangeChanged(min, max) {
  action("EXPERIENCE-RANGE-CHANGED", {
    min,
    max,
  });
}

export function campaignSelected(campaign) {
  action("CAMPAIGN-SELECTED", { campaign });
}

export function folderFilterChanged(filter) {
  action("FOLDER-FILTER-CHANGED", { filter });
}

export function applyFilters(filters) {
  action("APPLY-FILTERS", filters);

  hideFilters();
  reloadResumes();
}

export function showEditCampaign() {
  $(document).trigger("edit-folder");
}

export function hideEditCampaign() {
  $(document).trigger("rename-folder");
}

export function editCampaign(campaign) {
  action("SELECTED-CAMPAIGN-CHANGED", { campaign });
  showEditCampaign();
}

export function renameCampaign(campaign, name) {
  action("RENAMING-CAMPAIGN", { campaign, name });
  hideEditCampaign();

  var params = {
    id: campaign.id,
    title: name,
  };

  Api.post("rename-campaign", params, function (data) {
    action("CAMPAIGN-RENAMED", data);
  });
}

export function showDeleteCampaign() {
  $(document).trigger("confirm-delete-campaign");
}

export function hideDeleteCampaign() {
  $(document).trigger("delete-campaign");
}

export function deletingCampaign(campaign) {
  action("SELECTED-CAMPAIGN-CHANGED", { campaign });
  showDeleteCampaign();
}

export function deleteCampaign(campaign) {
  action("DELETING-CAMPAIGN", { campaign });
  hideDeleteCampaign();

  var params = { id: campaign.id };

  Api.post("delete-campaign", params, function (data) {
    action("CAMPAIGN-DELETED", data);
  });
}

export function openResume(id) {
  action("LOADING-RESUME", { id });
  Api.post("resume-admin/" + id, null, function (data) {
    action("ADMIN-RESUME-CHANGED", data);
    $(".spacer").animate({
      height: $(window).scrollTop() - $(".spacer").offset().top + 20,
    });
  });
}

export function saveInvitationTemplate(
  subject,
  message,
  textColor,
  color,
  logo
) {
  const params = {
    subject,
    message,
    textColor,
    color,
    logo,
  };
  hideMessageSendInvitation();
  closeUsersRemoveMsg();
  Api.post("save-admin-invitation-template/", params, function (data) {
    action("SHOW-SUCCESS-SAVE-INVITATION");
  });
}

export function saveActiveTemplate(data) {
  action("ACTIVE-TEMPLATE", data);
  hideSavedTemplates();
}

export function savePreviewTemplate(data) {
  reloadTemplates();
  action("PREVIEW-TEMPLATE", data);
}

export function minimizePanel() {
  action("MINIMIZE-PANEL");
}

export function changeMessage(message) {
  action("CHANGE-ACTIVE-MESSAGE", { message });
}

export function changeSubject(subject) {
  action("CHANGE-ACTIVE-SUBJECT", { subject });
}

export function changeTextColor(textColor) {
  action("CHANGE-ACTIVE-TEXT-COLOR", { textColor });
}

export function changeColor(color) {
  action("CHANGE-ACTIVE-COLOR", { color });
}

export function changeLogo(logo) {
  action("CHANGE-ACTIVE-LOGO", { logo });
}

export function removeAllSelected() {
  action("REMOVE-ALL-SELECTION");
  setTimeout(function () {
    action("RESET-LOADING-REMOVE");
  }, 1000);
}
export function changeLoading() {
  action("CHANGE-LOADING");
  indexRotate();
}
export function indexRotate() {
  Api.post("rotate", null, function (data) {
    action("ROTATE-INDEX", data);
  });
  reloadLogIndex();
}

export function reloadLogIndex() {
  Api.get("log-index", function (data) {
    action("LOG-CHANGED", data);
  });
}
export function hideMessageSendInvitation() {
  action("HIDE-MESSAGE-SEND-INVITATION");
}

export function hideMessageSavedInvitation() {
  action("HIDE-MESSAGE-SAVED-INVITATION");
}
export function reloadNewAdminResumes(data_resume) {
  Api.post("resumes-admin-removed", data_resume, function (data) {
    action("RESUME-REMOVE", data);
  }).always(function () {
    doReloadResumesAdminAfter();
    removeAllSelected();
    reloadLogIndex();
  });
}
export function changeLoadingSendInvitation() {
  action("CHANGE-LOADING-SEND-INVITATION");
}

export function closeUsersRemoveMsg() {
  action("HIDE-MESSAGE-USERS-REMOVE");
}
export function reloadStats(id) {
  Api.get("invitation-stats/" + id, function (data) {
    action("GET-STATS", data);
  });
}
export function reloadInvitationStats(id) {
  Api.get("invitation-stats/" + id, function (data) {
    action("GET-INVITATION-STATS", data);
  });
}
export function loadPreview() {
  $(document).trigger("show-preview");
}
export function hideResumeDetails() {
  action("HIDE-RESUME-DETAILS");
}

export function createdUserMap(campaign) {
  action("SELECTED-CAMPAIGN-CHANGED", { campaign });
  action("OPEN-CREATE-MAP");
  $(document).trigger("create-map-for-user");
}
export function createCompanyIdForUser(id) {
  action("COMPANYID-FOR-USER-CHANGED", { id });
}
export function createIdForUser(id) {
  action("ID-FOR-USER-CHANGED", { id });
}
export function mapForUser(campaign, params) {
  var params = {
    id: campaign.id,
    userId: params.id,
    companyId: params.companyId,
  };

  Api.post("create-user-map", params, function (data) {
    action("SUCCESS-CREATE-MAP");
    reloadAds();
  })
    .then((data) => {
      $(document).trigger("hide-map-for-user");
    })
    .fail((data) => {
      action("ERROR-CREATE-MAP");
    });
}

export function showMessageContainer() {
  $(document).trigger("show-message");
}

export function hideMessageContainer() {
  $(document).trigger("hide-message");
}



// WEBPACK FOOTER //
// ./src/modules/model/Creators.js